import { createClient } from '@supabase/supabase-js';

const supabaseUrl = process.env.REACT_APP_SUPABASE_DEFAULT_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_DEFAULT_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error('Missing AEC Supabase environment variables:', {
    url: supabaseUrl ? 'set' : 'MISSING',
    key: supabaseAnonKey ? 'set' : 'MISSING',
  });
}

export const supabaseAEC = supabaseUrl && supabaseAnonKey
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null;
